import React from 'react'

const JobSheetClosure = () => {
  return (
    <div>JobSheetClosure</div>
  )
}

export default JobSheetClosure